import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import "./Help.css";

export default function FieldHelp({ label, section, children }) {
  const popover = (
    <Popover className="field-help__popover">
      <Popover.Body>
        {children}
        {section && (
          <div className="mt-2">
            <a href={`/help#${section}`} target="_blank" rel="noopener noreferrer">More in the guide</a>
          </div>
        )}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger trigger="click" rootClose placement="top" overlay={popover}>
      <button
        type="button"
        className="field-help"
        aria-label={`About ${label}`}
        onClick={(e) => e.stopPropagation()}
      >
        ?
      </button>
    </OverlayTrigger>
  );
}
